'use client'

import React, {useEffect} from 'react'
import {getInjection} from '@runlab/di'
import {useRouter} from 'nextjs-toploader/app'
import {usePathname} from 'next/navigation'
import {useUpdateEffect} from 'react-use'
import {settings} from '@/src/config/settings'
import OfflinePage from '@/src/providers/offline'
import {isMobile, scrollToHeader} from '../shared/utils/functions'
import {
  createMobileRedirectsMap,
  MobileMappedRedirect,
} from '@/src/infrastructure/services/mobile-redirects'
import {AppOpenedRedirect} from '@/src/infrastructure/services/app-open-redirect'
import {AppOpenedRedirectInterface} from '@/src/ports/services/app-open-redirect'
import {CatalogEventTypes} from '@/src/core/domain/events/catalog.events'

const mappedRedirectService = new MobileMappedRedirect(createMobileRedirectsMap())

const appOpenedRedirectService = new AppOpenedRedirect(mappedRedirectService)

import('@/src/shared/utils/fetch-override')

export const PageProvider = ({children}: React.PropsWithChildren) => {
  const pathname = usePathname()

  const router = useRouter()

  useEffect(() => {
    const eventBus = getInjection('IEventBus')
    eventBus.subscribe(CatalogEventTypes.FiltersApply, () => {
      scrollToHeader()
    })
  }, [])

  useEffect(() => {
    const redirect = (path: string, appOpenedRedirectService: AppOpenedRedirectInterface) => {
      if (!isMobile()) {
        return
      }

      const redirectUrl = appOpenedRedirectService.do(path)

      if (redirectUrl) {
        router.push(redirectUrl)
      }
    }

    if (isMobile()) {
      import('@capacitor/app').then(({App}) => {
        App.addListener('appUrlOpen', (event: {url: string}) => {
          const path = event.url.split(settings.APP_NAME).pop()
          if (path) {
            redirect(path, appOpenedRedirectService)
          }
        })
      })
    }

    if (isMobile()) {
      const redirectUrl = appOpenedRedirectService.do(location.href)
      if (redirectUrl) {
        window.location.replace(redirectUrl)
      }
    }

    document.addEventListener('clickToProductBySearch', event => {
      const productEvent = event as Event & {detail: {slug: string}}

      redirect(productEvent.detail.slug, appOpenedRedirectService)

      const digiShield:
        | (HTMLElement & {
            __vue__: {$store: {commit: (name: string, value: any) => void}}
          })
        | null = document.querySelector('#digi-shield')

      if (digiShield) {
        try {
          digiShield.__vue__.$store.commit('setOpen', false)
        } catch (e: unknown) {
          getInjection('ILoggerService').error(
            'Ошибка при закрытии поиска после перехода на карточку товара',
            e,
          )
          getInjection('IErrorReporter').capture(e)
        }
      }
    })
  }, [])

  useUpdateEffect(() => {
    scrollToHeader()
  }, [pathname])

  return (
    <>
      {children}
      <OfflinePage />
    </>
  )
}
